import { Text } from '@mantine/core'
import ReportWrapper from '../ReportWrapper'
import React from 'react'
import ReportSectionHeading from '../ReportSectionHeading'

interface ReportFooterProps {
  sectionIndex?: string
}

export default function ReportFooter({ sectionIndex }: ReportFooterProps) {
  const reportItems = [
    '本报告的数据由用户本人明确授权后，向相关合法机构调取获得，仅向用户个人展示参考。',
    '同一用户七天内查询报告不得超过两次。报告有效期为30天，过期自动删除。',
    '若您的数据不全面，可能是数据具有延迟性或者合作信息机构未获取到您的数据。若数据有错误请联系客服。',
    '任何诱导信息修复获取非法利益的行为都是欺诈！如对报告内容有异议，请联系客服。我司不接受任何信息修复业务。',
  ]

  return (
    <ReportWrapper>
      <ReportSectionHeading title="报告说明" index={sectionIndex} />
      <div className="mt-2">
        {reportItems.map((item, index) => (
          <Text
            key={index}
            size="sm"
            component="p"
            className="text-gray-700"
            style={{
              lineHeight: 1.75,
              marginBottom: index === reportItems.length - 1 ? 0 : '10px',
            }}
          >
            {index + 1}. {item}
          </Text>
        ))}
      </div>
    </ReportWrapper>
  )
}
